import { Skeleton } from '@radix-ui/themes';
import cn from 'classnames';

import type {
  SkeletonConfig,
  SkeletonElement,
  SkeletonLine,
} from '../TanstackTable.types';

function isSkeletonLine(
  entry: SkeletonElement[] | SkeletonLine
): entry is SkeletonLine {
  return !Array.isArray(entry) && 'items' in entry;
}

export function SkeletonCell({ config }: { config: SkeletonConfig }) {
  return (
    <div className='flex w-full flex-col gap-fly-2'>
      {config.map((entry, lineIdx) => {
        const items = isSkeletonLine(entry) ? entry.items : entry;
        const lineClassName = isSkeletonLine(entry)
          ? entry.className
          : undefined;
        return (
          <div
            key={lineIdx}
            className={cn('flex items-center gap-fly-3', lineClassName)}
          >
            {items.map((item, itemIdx) => (
              <Skeleton
                key={itemIdx}
                width={item.width ?? '100%'}
                height={item.height ?? '16px'}
                className={cn('mt-1 mb-1 rounded-[100px]', item.className)}
              />
            ))}
          </div>
        );
      })}
    </div>
  );
}
